import FormattedList from 'I18n/components/FormattedList';
import FormattedMessage from 'I18n/components/FormattedMessage';
import unescapedText from 'I18n/utils/unescapedText';
import UIButton from 'UIComponents/button/UIButton';
import Immutable from 'immutable';
import { APP_CERTIFICATION_CREDENTIAL_ID } from 'marketplace-ui-apps-core/common/constants/Certification';
import { getHasAppCertificationCredential } from 'marketplace-ui-apps-core/common/utils/Certification';
import { getAppCategoryI18nKey, getCategoryFeatureI18nKey } from 'marketplace-ui-apps-core/common/utils/i18n';
import { AppSortToggleGroup } from 'marketplace-ui-apps-core/results/components/AppSortToggleGroup';
import { DEFAULT_APP_SORT_FIELD, DEFAULT_APP_SORT_ORDER } from 'marketplace-ui-apps-core/results/constants/sortConstants';
import { getAppSortOptionText } from 'marketplace-ui-apps-core/results/utils/sortUtils';
import MobilePanel from 'marketplace-ui-common/components/mobile/MobilePanel';
import MobilePanelBody from 'marketplace-ui-common/components/mobile/MobilePanelBody';
import MobilePanelFooter from 'marketplace-ui-common/components/mobile/MobilePanelFooter';
import MobilePanelHeader from 'marketplace-ui-common/components/mobile/MobilePanelHeader';
import { MobilePanelHeaderLeftButton, MobilePanelHeaderRightButton } from 'marketplace-ui-common/components/mobile/MobilePanelHeaderButton';
import MobilePanelNav from 'marketplace-ui-common/components/mobile/MobilePanelNav';
import { CUSTOMER_SUPPORT_LANGUAGES } from 'marketplace-ui-common/constants/Languages';
import { LanguageFilter } from 'marketplace-ui-common/filters/components/LanguageFilter';
import PlanCompatibilityFilter from 'marketplace-ui-common/filters/components/PlanCompatibilityFilter';
import ValidI18nMessage from 'marketplace-ui-common/i18n/components/ValidI18nMessage';
import { getHubSpotFeatureI18nKey, getTierI18nKey } from 'marketplace-ui-common/utils/i18n';
import { useContext, useState } from 'react';
import { useSelector } from 'react-redux';
import { AutoSizer } from 'react-virtualized';
import * as FilterKey from '../../../constants/search/FilterKey';
import { useAppContext } from '../../../context/AppContext';
import StorefrontFiltersContext from '../../../context/StorefrontFiltersContext';
import StorefrontUsageTrackerContext from '../../../context/StorefrontUsageTrackerContext';
import CategoryFeaturesFilter from '../sidebar/filters/CategoryFeaturesFilter';
import { CategoryV2Filter } from '../sidebar/filters/CategoryV2Filter';
import CertifiedToggle from '../sidebar/filters/CertifiedToggle';
import DataSyncDirectionFilter from '../sidebar/filters/DataSyncDirectionFilter';
import HubSpotFeaturesFilter from '../sidebar/filters/HubSpotFeaturesFilter';
import IntegrationsFilter from '../sidebar/filters/IntegrationsFilter';
import PriceFilter from '../sidebar/filters/PriceFilter';
import SupportSourceFilter from '../sidebar/filters/SupportSourceFilter';
import { MobileFilterPanelContext } from './MobileFilterPanelContext';
import { MobileFilterPanelItem } from './MobileFilterPanelItem';

// @ts-expect-error untyped import
import { getIsUngatedForRecategorization } from '../../../selectors/auth';
import { getDataSyncFilterI18nKey, getPlanTypeFilterI18nKey, getSupportSourceFilterI18nKey
// @ts-expect-error untyped import
} from '../../../utils/i18n';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function MobileFilterPanel({
  onClose
}) {
  const appContext = useAppContext();
  const {
    clearFilters,
    filters,
    updateAllFilters
  } = useContext(StorefrontFiltersContext);
  const {
    trackInteraction
  } = useContext(StorefrontUsageTrackerContext);
  const [appliedFilters, setAppliedFilters] = useState(filters);
  const [openFilterPanel, setOpenFilterPanel] = useState();
  const isUngatedForRecategorization = useSelector(getIsUngatedForRecategorization);
  const {
    [FilterKey.SORT_FIELD]: sortFieldValue,
    [FilterKey.SORT_ORDER]: sortOrderValue,
    [FilterKey.CATEGORY_V2]: categoryV2Value,
    [FilterKey.CATEGORY]: categoryValue,
    [FilterKey.CATEGORY_FEATURES]: categoryFeaturesValue,
    [FilterKey.PRICING]: planTypeValue,
    [FilterKey.PLAN_COMPATIBLE]: planCompatibleValue,
    [FilterKey.TIERS]: tiersValue,
    [FilterKey.HUBSPOT_FEATURES]: hubspotFeaturesValue,
    [FilterKey.INTEGRATIONS]: integrationsValue,
    [FilterKey.CREDENTIALS]: credentialsValue,
    [FilterKey.SYNC]: syncValue,
    [FilterKey.APP_LANGUAGES]: appLanguagesValue,
    [FilterKey.SUPPORT_LANGUAGES]: supportLanguagesValue,
    [FilterKey.SUPPORT_SOURCE]: supportSourceValue
  } = appliedFilters;
  const onApplyFilters = () => {
    updateAllFilters(appliedFilters);
    onClose();
  };
  const handleUpdateAppliedFilter = (key, value) => {
    setAppliedFilters(prev => prev.set(key, value));
  };
  const onCloseFilterPanel = () => {
    setOpenFilterPanel(undefined);
  };
  return /*#__PURE__*/_jsx(MobileFilterPanelContext.Provider, {
    value: {
      openFilterPanel,
      onApplyFilters,
      onCloseFilterPanel,
      onOpenFilterPanel: setOpenFilterPanel
    },
    children: /*#__PURE__*/_jsx(MobilePanel, {
      align: "bottom",
      open: true,
      children: /*#__PURE__*/_jsxs("div", {
        "data-test-id": "mobile-filter-panel",
        children: [/*#__PURE__*/_jsx(MobilePanelHeader, {
          itemLeft: /*#__PURE__*/_jsx(MobilePanelHeaderLeftButton, {
            autoFocus: true,
            onClick: onClose,
            tabIndex: 0,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "appMarketplace.storefront.mobileNavigation.cancel"
            })
          }),
          itemRight: /*#__PURE__*/_jsx(MobilePanelHeaderRightButton, {
            onClick: onApplyFilters,
            tabIndex: 1,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "appMarketplace.storefront.filters.apply"
            })
          }),
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "appMarketplace.storefront.filters.filter"
          })
        }), /*#__PURE__*/_jsxs(MobilePanelBody, {
          children: [/*#__PURE__*/_jsx(MobilePanelNav, {
            title: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "appMarketplace.storefront.results.sort.mobileLabel"
            }),
            children: /*#__PURE__*/_jsx(MobileFilterPanelItem, {
              filterKey: "sorts",
              panelTitle: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "appMarketplace.storefront.results.sort.mobileLabel"
              }),
              title: getAppSortOptionText(sortFieldValue || DEFAULT_APP_SORT_FIELD, sortOrderValue || DEFAULT_APP_SORT_ORDER),
              children: /*#__PURE__*/_jsx(AppSortToggleGroup, {
                onChange: ({
                  sortField,
                  sortOrder
                }) => {
                  handleUpdateAppliedFilter('sortField', sortField);
                  handleUpdateAppliedFilter('sortOrder', sortOrder);
                },
                value: {
                  sortField: sortFieldValue || DEFAULT_APP_SORT_FIELD,
                  sortOrder: sortOrderValue || DEFAULT_APP_SORT_ORDER
                }
              })
            })
          }), /*#__PURE__*/_jsxs(MobilePanelNav, {
            title: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "appMarketplace.storefront.filters.mobileLabel"
            }),
            children: [isUngatedForRecategorization && /*#__PURE__*/_jsx(MobileFilterPanelItem, {
              filterKey: "categoryV2",
              subtitle: /*#__PURE__*/_jsx(FormattedList, {
                children: categoryV2Value.map((value, index) => /*#__PURE__*/_jsx(ValidI18nMessage, {
                  message: getAppCategoryI18nKey(value)
                }, `${index}-${value}`))
              }),
              title: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "appMarketplace.storefront.filters.category.titleText"
              }),
              children: /*#__PURE__*/_jsx(CategoryV2Filter, {
                onChange: ({
                  target: {
                    value
                  }
                }) => handleUpdateAppliedFilter('categoryV2', Immutable.Set(value)),
                scrollable: false,
                value: categoryV2Value.toArray()
              })
            }), !isUngatedForRecategorization && categoryValue && /*#__PURE__*/_jsx(MobileFilterPanelItem, {
              filterKey: "categoryFeatures",
              subtitle: /*#__PURE__*/_jsx(FormattedList, {
                children: categoryFeaturesValue.map((value, index) => /*#__PURE__*/_jsx(ValidI18nMessage, {
                  message: getCategoryFeatureI18nKey(categoryValue, value)
                }, `${index}-${value}`))
              }),
              title: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "appMarketplace.storefront.filters.categoryFeatures.titleText"
              }),
              children: /*#__PURE__*/_jsx(CategoryFeaturesFilter, {
                activeCategory: categoryValue,
                onChange: ({
                  target: {
                    value
                  }
                }) => handleUpdateAppliedFilter('categoryFeatures', Immutable.Set(value)),
                scrollable: false,
                value: categoryFeaturesValue.toArray()
              })
            }), /*#__PURE__*/_jsx(MobileFilterPanelItem, {
              filterKey: "planType",
              subtitle: planTypeValue && /*#__PURE__*/_jsx(ValidI18nMessage, {
                message: getPlanTypeFilterI18nKey(planTypeValue)
              }),
              title: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "appMarketplace.storefront.filters.planType.titleText"
              }),
              children: /*#__PURE__*/_jsx(PriceFilter, {
                onChange: ({
                  target: {
                    value
                  }
                }) => handleUpdateAppliedFilter('planType', value),
                value: planTypeValue
              })
            }), /*#__PURE__*/_jsx(MobileFilterPanelItem, {
              filterKey: "tiers",
              subtitle: planCompatibleValue ? /*#__PURE__*/_jsx(FormattedMessage, {
                message: "appMarketplace.storefront.filters.compatibility.items.compatible"
              }) : /*#__PURE__*/_jsx(FormattedList, {
                children: tiersValue.map((tier, index) => /*#__PURE__*/_jsx(ValidI18nMessage, {
                  message: getTierI18nKey(tier)
                }, `${index}-${tier}`))
              }),
              title: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "appMarketplace.storefront.filters.compatibility.titleText"
              }),
              children: /*#__PURE__*/_jsx(PlanCompatibilityFilter, {
                appContext: appContext,
                ariaLabel: unescapedText('appMarketplace.storefront.filters.compatibility.titleText'),
                onChange: ({
                  target: {
                    value: {
                      portalCompatible,
                      tiers
                    }
                  }
                }) => {
                  handleUpdateAppliedFilter('tiers', Immutable.Set(tiers));
                  handleUpdateAppliedFilter('onlyHubInstallable', portalCompatible);
                },
                value: {
                  portalCompatible: planCompatibleValue,
                  tiers: tiersValue.toArray()
                }
              })
            }), /*#__PURE__*/_jsx(MobileFilterPanelItem, {
              filterKey: "hubSpotFeatures",
              subtitle: /*#__PURE__*/_jsx(FormattedList, {
                children: hubspotFeaturesValue.map((value, index) => /*#__PURE__*/_jsx(ValidI18nMessage, {
                  message: getHubSpotFeatureI18nKey(value)
                }, `${index}-${value}`))
              }),
              title: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "appMarketplace.storefront.filters.hubspotFeatures.titleText"
              }),
              children: /*#__PURE__*/_jsx(HubSpotFeaturesFilter, {
                onChange: ({
                  target: {
                    value
                  }
                }) => handleUpdateAppliedFilter('hubSpotFeatures', Immutable.Set(value)),
                trackInteraction: trackInteraction,
                value: hubspotFeaturesValue.toArray()
              })
            }), /*#__PURE__*/_jsx(MobileFilterPanelItem, {
              filterKey: "integrations",
              subtitle: /*#__PURE__*/_jsx(FormattedList, {
                children: integrationsValue.map((value, index) => /*#__PURE__*/_jsx("span", {
                  children: value
                }, `${index}-integration`))
              }),
              title: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "appMarketplace.storefront.filters.integrations.titleText"
              }),
              children: /*#__PURE__*/_jsx(AutoSizer, {
                children: ({
                  height,
                  width
                }) => /*#__PURE__*/_jsx("div", {
                  style: {
                    height,
                    width
                  },
                  children: /*#__PURE__*/_jsx(IntegrationsFilter, {
                    maxHeight: height,
                    onChange: ({
                      target: {
                        value
                      }
                    }) => handleUpdateAppliedFilter('integrations', Immutable.Set(value)),
                    trackInteraction: trackInteraction,
                    value: integrationsValue.toArray()
                  })
                })
              })
            }), /*#__PURE__*/_jsx(MobileFilterPanelItem, {
              filterKey: "credentials",
              subtitle: getHasAppCertificationCredential(credentialsValue) ? /*#__PURE__*/_jsx(FormattedMessage, {
                message: "appMarketplace.storefront.filters.certified.item"
              }) : null,
              title: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "appMarketplace.storefront.filters.certified.titleText"
              }),
              children: /*#__PURE__*/_jsx(CertifiedToggle, {
                onChange: value => handleUpdateAppliedFilter('credentials', value ? [APP_CERTIFICATION_CREDENTIAL_ID] : []),
                value: getHasAppCertificationCredential(credentialsValue)
              })
            }), /*#__PURE__*/_jsx(MobileFilterPanelItem, {
              filterKey: "sync",
              subtitle: syncValue && /*#__PURE__*/_jsx(ValidI18nMessage, {
                message: getDataSyncFilterI18nKey(syncValue)
              }),
              title: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "appMarketplace.storefront.filters.sync.titleText"
              }),
              children: /*#__PURE__*/_jsx(DataSyncDirectionFilter, {
                onChange: ({
                  target: {
                    value
                  }
                }) => handleUpdateAppliedFilter('sync', value),
                value: syncValue
              })
            }), /*#__PURE__*/_jsx(MobileFilterPanelItem, {
              filterKey: "appLanguages",
              subtitle: /*#__PURE__*/_jsx(FormattedList, {
                children: appLanguagesValue.map((lang, index) => /*#__PURE__*/_jsx(ValidI18nMessage, {
                  message: `SharedI18nStrings.languageNames.${lang}`
                }, `${index}-${lang}`))
              }),
              title: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "appMarketplace.storefront.filters.appLanguages.titleText"
              }),
              children: /*#__PURE__*/_jsx(LanguageFilter, {
                languages: CUSTOMER_SUPPORT_LANGUAGES,
                name: "appLanguages",
                onChange: value => handleUpdateAppliedFilter('appLanguages', Immutable.Set(value)),
                searchable: true,
                value: appLanguagesValue.toArray()
              })
            }), /*#__PURE__*/_jsx(MobileFilterPanelItem, {
              filterKey: "supportLanguages",
              subtitle: /*#__PURE__*/_jsx(FormattedList, {
                children: supportLanguagesValue.map((lang, index) => /*#__PURE__*/_jsx(ValidI18nMessage, {
                  message: `SharedI18nStrings.languageNames.${lang}`
                }, `${index}-${lang}`))
              }),
              title: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "appMarketplace.storefront.filters.supportedLanguages.titleText"
              }),
              children: /*#__PURE__*/_jsx(LanguageFilter, {
                languages: CUSTOMER_SUPPORT_LANGUAGES,
                name: "supportLanguages",
                onChange: value => handleUpdateAppliedFilter('supportLanguages', Immutable.Set(value)),
                searchable: true,
                value: supportLanguagesValue.toArray()
              })
            }), /*#__PURE__*/_jsx(MobileFilterPanelItem, {
              filterKey: "supportSource",
              subtitle: supportSourceValue && /*#__PURE__*/_jsx(ValidI18nMessage, {
                message: getSupportSourceFilterI18nKey(supportSourceValue)
              }),
              title: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "appMarketplace.storefront.filters.supportSource.titleText"
              }),
              children: /*#__PURE__*/_jsx(SupportSourceFilter, {
                onChange: ({
                  target: {
                    value
                  }
                }) => handleUpdateAppliedFilter('supportSource', value),
                value: supportSourceValue
              })
            })]
          })]
        }), /*#__PURE__*/_jsx(MobilePanelFooter, {
          children: /*#__PURE__*/_jsx(UIButton, {
            use: "link",
            onClick: () => {
              clearFilters();
              onClose();
            },
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "appMarketplace.storefront.mobileNavigation.clearAll"
            })
          })
        })]
      })
    })
  });
}